var axios = require('axios')

// search client
axios.searchClient = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/clients' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// get list role
axios.getListRoles = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/roles?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// create a new user
axios.createUser = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/users', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// create a new user
axios.updateUser = function (params, data, success, callBackError) {
  this.put(process.env.prefix_tenant + '/users/' + params, data)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getUserList = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/users?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getUserDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/users/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPermissionList = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/permissions' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createRole = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/roles', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateRole = function (params, data, success, callBackError) {
  this.put(process.env.prefix_tenant + '/roles/' + params, data)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getRoleDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/roles/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createPermission = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/permissions', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updatePermission = function (params, data, success, callBackError) {
  this.put(process.env.prefix_tenant + '/permissions/' + params, data)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPermissionDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/permissions/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.forgotPassword = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/forgot-password', params)
    .then(response => {
      // success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.forgotPasswordToken = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/forgot-password/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        // callBackError(error.response.data)
      }
    }
  })
}

axios.resetPassword = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/reset-password', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMe = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/me/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateMe = function (params, data, success, callBackError) {
  this.put(process.env.prefix_tenant + '/me/' + params, data)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.logoutAllUsers = function (clientId, success, callBackError) {
  this.put(process.env.prefix_tenant + '/logout-all-users', { client_id: clientId })
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getUserRoles = function (success, callBackError) {
  this.get(process.env.prefix_tenant + '/me/roles')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/User.js